import { lazy } from 'react';

import { MonteraRoute } from 'src/utils/router';

export const SupportRoute: MonteraRoute<'support'> = {
  name: 'support',
  path: '/support',
  comp: () => lazy(() => import('./index')),
};
